<div class="setting-section">
  <app-agent-mngt-detail [machines]="machines" [agentsData]="dataSource.data" (agentSaved)="onAgentSaved($event)"></app-agent-mngt-detail>

  <div class="fc-mngt-toolbar">
    <h2 class="fc-mngt-title">Agents</h2>
    <div class="fc-mngt-search">
      <span class="material-icons fc-mngt-search-icon">search</span>
      <input class="fc-mngt-search-input" type="text" placeholder="Filter by username / serial number…" (keyup)="doFilter($any($event.target).value)" />
    </div>
  </div>

  <table mat-table [dataSource]="dataSource" class="agentsTable" matSort>
    <ng-container matColumnDef="username">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Username</th>
      <td mat-cell *matCellDef="let element">{{ element.username }}</td>
    </ng-container>
    <ng-container matColumnDef="machine">
      <th mat-header-cell *matHeaderCellDef>Machine SN</th>
      <td mat-cell *matCellDef="let element">{{ element.machineSerialNumber }}</td>
    </ng-container>
    <ng-container matColumnDef="enabled">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Enabled</th>
      <td mat-cell *matCellDef="let element">
        <mat-checkbox [checked]="element.enabled" disabled="true"></mat-checkbox>
      </td>
    </ng-container>
    <ng-container matColumnDef="lastSeenOnline">
      <th mat-header-cell *matHeaderCellDef>Last Seen Online</th>
      <td mat-cell *matCellDef="let element">{{ element.lastSeenOnline | date: "medium" }}</td>
    </ng-container>
    <ng-container matColumnDef="Actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element" class="actionButtonCol">
        <button class="fc-action-btn" (click)="edit(element)">Edit</button>
        <button class="fc-action-btn" (click)="generatePwdConfirmDialog(element)" title="Generate and send new password">Gen. Pwd</button>
        <button class="fc-action-btn fc-action-btn--danger" (click)="deleteConfirmDialog(element)">Delete</button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell fc-no-data" colspan="5">No agents found</td>
    </tr>
  </table>
</div>
